module.exports = __webpack_public_path__ + "static/media/serviceC.98225529.jpg";